import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';

import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import Chip from '@mui/material/Chip';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components

import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { ConfirmDialog } from 'src/components/custom-dialog';


// ----------------------------------------------------------------------

export default function TourGuideItemSchemaTableRow({
  row,
  selected,
  onEditRow,
  onEditRowEnable,
  onViewRow,
  onSelectRow,
  onDeleteRow,
}) {
  const {
    id,
    configurationName,
    schemaName,
    categoryName,
    headerId,
    type,
    discountMethod,
    amount,
    item,
    isEnabled,
    tourGuideSchemaLine,
    // Add other fields as needed
  } = row;



  const confirm = useBoolean();



  const popover = usePopover();

  console.log('isEnabled', isEnabled);
  console.log("Sdsdadaada", row);

  return (
    <>
      <TableRow sx={{ height: 0, p: 0 }}>
        <TableCell sx={{ whiteSpace: 'nowrap', py: 0 }}>{id}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap', py: 0 }}>{item?.item_id}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap', py: 0 }}>{tourGuideSchemaLine?.configurationName || ''}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap', py: 0 }}>
          <Chip label={isEnabled ? 'Enabled' : 'Disabled'} color={isEnabled ? 'success' : 'default'} size="small" />
        </TableCell>
        <TableCell align="center" sx={{ px: 1, whiteSpace: 'nowrap', py: 0 }}>
          <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>
      <CustomPopover open={popover.open} onClose={popover.onClose} arrow="right-top" sx={{ width: 140 }}>
        {/* <MenuItem
          onClick={() => {
            confirm.onTrue();
            popover.onClose();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="solar:trash-bin-trash-bold"/>
          Delete
        </MenuItem> */}
        <MenuItem
          onClick={() => {
            onEditRowEnable(row, isEnabled);
            popover.onClose();
          }}
        >
          <Iconify icon={isEnabled ? "mdi:toggle-switch-off" : "mdi:toggle-switch"} />
          {isEnabled ? "Disable" : "Enable"}
        </MenuItem>
        {/* <MenuItem
          onClick={() => {
            onEditRow(row);
            popover.onClose();
          }}
        >
          <Iconify icon="solar:pen-bold" />
          Edit
        </MenuItem> */}
        {/* <MenuItem
            onClick={() => {
            onViewRow();
            popover.onClose();
            }}
          >
            <Iconify icon="mdi:eye"/>
            View
          </MenuItem> */}
      </CustomPopover>
      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content="Are you sure want to delete?"
        action={
          <Button variant="contained" color="error" onClick={onDeleteRow}>
            Delete
          </Button>
        }
      />
    </>
  );
}

TourGuideItemSchemaTableRow.propTypes = {
  onDeleteRow: PropTypes.func,
  onEditRow: PropTypes.func,
  onEditRowEnable: PropTypes.func,
  onViewRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  row: PropTypes.object,
  selected: PropTypes.bool,
};
